import React, { useContext } from 'react';
import { InlineOrBlockSize } from '../Types';
import { GroupContext } from '../layout/GroupContext';
import classNames from 'classnames';
import styles from './Button.scss';

export type ButtonMode = '' | 'secondary';

export interface ButtonProps {
  /**
   * Button Id
   */
  id?: string;
  /**
   * Button contents
   */
  label: string | JSX.Element;
  /**
   * Click handler
   */
  onClick: () => void;
  /**
   * Disabled element
   */
  size?: InlineOrBlockSize;
  /**
   * Disabled element
   */
  disabled?: boolean;
  /**
   * Button type
   */
  mode?: ButtonMode;
  /**
   * Additional class names
   */
  className?: string;

  describedBy?: string;

  title?: string;
}

/**
 * Primary UI component for user interaction
 */
export const Button: React.FC<ButtonProps> = (props) => {
  const groupCtx = useContext(GroupContext);

  return (
    <button
      id={props.id ? props.id : undefined}
      className={classNames(
        styles['au-btn'],
        {
          [styles['au-btn--secondary']]: props.mode == 'secondary',
          [styles['au-btn--block']]: props.size == 'block',
        },
        groupCtx.className,
        props.className,
      )}
      onClick={props.onClick}
      disabled={props.disabled}
      aria-labelledby={props.describedBy || ''}
      title={props.title || undefined}>
      {props.label}
    </button>
  );
};
